import { render, staticRenderFns } from "./SectionQuiz.vue?vue&type=template&id=accbc3e2&scoped=true&"
import script from "./SectionQuiz.vue?vue&type=script&lang=js&"
export * from "./SectionQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SectionQuiz.vue?vue&type=style&index=0&id=accbc3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accbc3e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('accbc3e2')) {
      api.createRecord('accbc3e2', component.options)
    } else {
      api.reload('accbc3e2', component.options)
    }
    module.hot.accept("./SectionQuiz.vue?vue&type=template&id=accbc3e2&scoped=true&", function () {
      api.rerender('accbc3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionplan/SectionQuiz.vue"
export default component.exports